import * as React from 'react'
import { ReactElement } from 'react';

export interface Props {
  title: any,
  description?: string | ReactElement,
  isBeta?: boolean,
  aboveTitle?: ReactElement
}

const PageHeader: React.FC<Props> = ({ title, description, aboveTitle, isBeta=false }: Props) => {

  return (
    <div className="text-gray-700 pt-24 pb-16">
      {aboveTitle}
      <h1 className="text-3xl text-center">
        <span className="font-medium">{title}
        {isBeta &&
        <span className="align-top pl-1 text-sm font-bold">BETA</span>
        }
        </span>
      </h1>
      {description &&
        <h2 className="text-xl text-center">{description}</h2>
      }

    </div>
  );
}

export default PageHeader;


